import {
  regex
} from 'vuelidate/lib/validators/common';
import {
  zipRegex
} from '@/constants';

export default regex('zipCode', zipRegex);